module.exports = __webpack_public_path__ + "img/contectBg.e7bc3669.jpg";